module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjkiIGhlaWdodD0iOTAiIHZpZXdCb3g9IjAgMCA2OSA5MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTMzLjE4MzggMEgwLjk1MjE0OEwzNi43NjUxIDQ0LjkyNDJMMC45NTIxNDggODkuODQ4NUgzMy4xODM4TDY4Ljk5NjggNDQuOTI0MkwzMy4xODM4IDBaIiBmaWxsPSIjMDU5QkNBIi8+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/arrow2.svg
// module id = g39y
// module chunks = 1